module.exports = __webpack_public_path__ + "static/media/kodjo.bc77c3bd.jpg";